<template>
  <b-row>
    <b-col md="8">
      <b-form inline @submit.prevent="startSearch">
        <b-form-input v-model="searchString" placeholder="Search" class="mx-1"></b-form-input>
        <b-button @click="startSearch" variant="primary" class="m-1">Search</b-button>
        <b-button @click="clearSearch" variant="danger" class="m-1">Clear Search</b-button>
      </b-form>
    </b-col>
    <b-col md="4" v-if="totalItems > 0">
      <b-pagination v-model="currentPage" :per-page="itemsPerPage" :limit="5" :total-rows="totalItems"
        @change="pageChanged" :disabled="dataLoading" align="fill" class="mt-1">
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';
import { restoreFilters, storeFilters } from './filterstorage';

let intervalRef = null;

export default {
  data() {
    const filters = restoreFilters('users');
    return {
      apiUrl: 'users',
      currentPage: filters?.currentPage ?? 1,
      itemsPerPage: 10,
      totalItems: -1,
      items: [],
      searchString: filters?.searchString ?? '',
      fixedSearchString: filters?.fixedSearchString ?? '',
      dataLoading: false,
      filters: [],
    };
  },
  props: {
    perPage: {
      type: [Number],
      required: false,
    },
    queryStructure: {
      type: [Object],
      required: true,
    },
    pollingInterval: {
      type: [Number],
      required: false,
      default: 0,
    },

  },
  async created() {
    if (this.perPage) {
      this.itemsPerPage = this.perPage;
    }
    this.pageChanged();
  },
  beforeDestroy() {
    this.savePagination();
    this.resetPollingInterval();
  },
  methods: {
    // fetches the data retuns the promise
    fetchData(newPage) {
      // generate params
      const params = {
        [this.queryStructure.pagePropName]: newPage,
        [this.queryStructure.perPagePropName]: this.itemsPerPage,
        [this.queryStructure.searchPropName]: this.fixedSearchString,
      };
      // custom keys and values
      if (this.queryStructure.custom && Object.keys(this.queryStructure).length > 0) {
        Object.keys(this.queryStructure.custom).forEach((k) => {
          params[k] = this.queryStructure.custom[k];
        });
      }
      // nuke empty strings, null and undefined values
      Object.keys(params).forEach((k) => {
        if (
          [null, undefined].includes(params[k])
          || (typeof params[k] === 'string' && params[k].trim().length === 0)
        ) {
          delete params[k];
        }
      });
      this.filters = params;
      // fetch the data
      const deferred = new Promise((resolve, reject) => {
        const axiosPromise = axios.get(apiUrlPrefix + this.apiUrl, { params });
        axiosPromise.then((r) => { resolve(r.data); });
        axiosPromise.catch(() => { reject(); });
      });
      return deferred;
    },
    // updates the data
    pageChanged(np) {
      if (np) this.currentPage = np;
      const newPage = np || this.currentPage;
      this.dataLoading = true;
      this.$emit('items-updated', null);
      this.resetPollingInterval();
      this.fetchData(newPage).then((data) => {
        const responseData = data[this.queryStructure.responseDataKey];
        this.items = responseData.data;
        this.totalItems = responseData.total;
        this.setPollingInterval();
        // check edge case when last item on last page and cover an edge case when there's 0 items
        const maxPage = Math.ceil(this.totalItems / this.itemsPerPage) || 1;
        if (maxPage < this.currentPage) {
          this.currentPage = maxPage;
          this.pageChanged();
        }
        this.savePagination();
        this.$emit('items-updated', this.items);
      }, () => {
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    startSearch() {
      this.fixedSearchString = this.searchString;
      this.currentPage = 1;
      this.pageChanged();
    },
    clearSearch() {
      this.fixedSearchString = '';
      this.searchString = '';
      this.currentPage = 1;
      this.pageChanged(1);
    },
    resetPollingInterval() {
      if (intervalRef) {
        window.clearInterval(intervalRef);
        intervalRef = null;
      }
    },
    setPollingInterval() {
      if (this.pollingInterval > 0) {
        intervalRef = window.setInterval(() => {
          this.pageChanged();
        }, this.pollingInterval * 1000);
      }
    },
    savePagination() {
      storeFilters('users', {
        searchString: this.searchString,
        fixedSearchString: this.fixedSearchString,
        currentPage: this.currentPage
      });
    }
  },
};
</script>
